module.exports = __webpack_public_path__ + "img/detail_portrait_default_men@3x.f92c62cd.png";